import ReportsTypes from './Reports.types';

const INITIAL_STATE = {
	reportsResponse: null,
	managementLeaveReport: null,
	designationLeaveReport: null,
	monthlyAttendanceSummaryReport: null,
	monthlyCheckoutReport: null,
	isLoading: false,
	error: null
};

const reportsReducer = (state = INITIAL_STATE, action: { type: string; payload?: any }) => {
	switch (action.type) {
		case ReportsTypes.REPORT_START:
			console.log('Reports reducer: handling REPORT_START', action);
			return { 
				...state, 
				reportsResponse: null,
				isLoading: true,
				error: null 
			};
		case ReportsTypes.REPORT_SUCCESS:
			console.log('Reports reducer: handling REPORT_SUCCESS', action);
			// Handle both array and object responses
			const successData = action.payload.data || action.payload;
			return { 
				...state, 
				reportsResponse: { 
					status: 'success', 
					data: Array.isArray(successData) ? successData : 
						  successData.data ? successData.data : 
						  successData
				},
				isLoading: false,
				error: null
			};
		case ReportsTypes.REPORT_FAILURE:
			console.log('Reports reducer: handling REPORT_FAILURE', action);
			return { 
				...state, 
				reportsResponse: { 
					status: 'error', 
					message: action.payload 
				},
				isLoading: false,
				error: action.payload
			};
		case ReportsTypes.REPORT_RESPONSE_REST_START:
			console.log('Reports reducer: handling REPORT_RESPONSE_REST_START');
			return { 
				...state, 
				reportsResponse: null,
				isLoading: false,
				error: null
			};
		case ReportsTypes.GET_MANAGEMENT_LEAVE_REPORT:
			return { 
				...state, 
				managementLeaveReport: null,
				isLoading: true,
				error: null 
			};
		case ReportsTypes.GET_MANAGEMENT_LEAVE_REPORT_SUCCESS:
			return { 
				...state, 
				managementLeaveReport: action.payload,
				isLoading: false,
				error: null 
			};
		case ReportsTypes.GET_MANAGEMENT_LEAVE_REPORT_FAILURE:
			return { 
				...state, 
				managementLeaveReport: { error: action.payload },
				isLoading: false,
				error: action.payload 
			};
		case ReportsTypes.MANAGEMENT_LEAVE_REPORT_RESET:
			return { 
				...state, 
				managementLeaveReport: null,
				isLoading: false,
				error: null 
			};
		case ReportsTypes.GET_DESIGNATION_LEAVE_REPORT:
			return { 
				...state, 
				designationLeaveReport: null,
				isLoading: true,
				error: null 
			};
		case ReportsTypes.GET_DESIGNATION_LEAVE_REPORT_SUCCESS:
			return { 
				...state, 
				designationLeaveReport: action.payload,
				isLoading: false,
				error: null 
			};
		case ReportsTypes.GET_DESIGNATION_LEAVE_REPORT_FAILURE:
			return { 
				...state, 
				designationLeaveReport: { error: action.payload },
				isLoading: false,
				error: action.payload 
			};
		case ReportsTypes.DESIGNATION_LEAVE_REPORT_RESET:
			return { 
				...state, 
				designationLeaveReport: null,
				isLoading: false,
				error: null 
			};
		case ReportsTypes.GET_MONTHLY_ATTENDANCE_SUMMARY_REPORT:
			return { 
				...state, 
				monthlyAttendanceSummaryReport: null,
				isLoading: true,
				error: null 
			};
		case ReportsTypes.GET_MONTHLY_ATTENDANCE_SUMMARY_REPORT_SUCCESS:
			return { 
				...state, 
				monthlyAttendanceSummaryReport: action.payload,
				isLoading: false,
				error: null 
			};
		case ReportsTypes.GET_MONTHLY_ATTENDANCE_SUMMARY_REPORT_FAILURE:
			return { 
				...state, 
				monthlyAttendanceSummaryReport: { error: action.payload },
				isLoading: false,
				error: action.payload 
			};
		case ReportsTypes.MONTHLY_ATTENDANCE_SUMMARY_REPORT_RESET:
			return { 
				...state, 
				monthlyAttendanceSummaryReport: null,
				isLoading: false,
				error: null 
			};
		case ReportsTypes.GET_MONTHLY_CHECKOUT_REPORT:
			return { 
				...state, 
				monthlyCheckoutReport: null,
				isLoading: true,
				error: null 
			};
		case ReportsTypes.GET_MONTHLY_CHECKOUT_REPORT_SUCCESS:
			return { 
				...state, 
				monthlyCheckoutReport: action.payload,
				isLoading: false,
				error: null 
			};
		case ReportsTypes.GET_MONTHLY_CHECKOUT_REPORT_FAILURE:
			return { 
				...state, 
				monthlyCheckoutReport: { error: action.payload },
				isLoading: false,
				error: action.payload 
			};
		case ReportsTypes.MONTHLY_CHECKOUT_REPORT_RESET:
			return { 
				...state, 
				monthlyCheckoutReport: null,
				isLoading: false,
				error: null 
			};
		default:
			return state;
	}
};

export default reportsReducer;
